import styles from "./scrolly.module.css"
import { useState, Fragment } from "react"
import classNames from "classnames"
import { useRef } from "react"
import gsap from "gsap"
import ScrollTrigger from "gsap/dist/ScrollTrigger"
import { useGSAP } from "@gsap/react"

export default function Scrolly({ block }) {
  const [scrollTexts, setScrollText] = useState(block.attrs.groups)
  gsap.registerPlugin(useGSAP)
  gsap.registerPlugin(ScrollTrigger)

  const container = useRef()
  useGSAP(() => {
    // It won't work at expectet without the timeout...
    setTimeout(function () {
      ScrollTrigger.normalizeScroll(true)
      let currentStop = 0
      let triggerOffset = screen.width / 2

      let scrolly = gsap.to(".scrollyContent", {
        xPercent: -100,
        x: () => innerWidth,
        ease: "none",
        scrollTrigger: {
          trigger: ".scrollyContent",
          end: () => "+=8000",
          start: "center center",
          scrub: 0.1,
          pin: true,
          invalidateOnRefresh: false,
          pinType: "transform",
          markers: false,
          onUpdate: function () {
            let triggerItems = document.querySelectorAll(".triggerItem")

            if (triggerItems[currentStop] === undefined) {
              return
            }

            let info = triggerItems[currentStop].getBoundingClientRect()

            if (info.x < triggerOffset) {
              scrollTexts[currentStop].texts.forEach((element, index) => {
                let textItem = [...scrollTexts]
                textItem[currentStop].texts[index].show = 1
                setScrollText(textItem)
              })

              currentStop++
            }
          }
        }
      }) // End of gasp

      let accordions = document.querySelectorAll(
        '[data-block="theme/accordion"] > header > div'
      )

      accordions.forEach((item) => {
        item.addEventListener("click", () => {
          setTimeout(() => {
            scrolly.scrollTrigger.refresh()
          }, 100)
        })
      })
    }, 100)
  })

  const TextBox = () => {
    return scrollTexts.map((scrollGroup, groupIndex) => {
      return scrollGroup.texts.map((item, index) => {
        return (
          <Fragment key={groupIndex}>
            {index == 0 && (
              <div
                className="triggerItem"
                style={{
                  position: "absolute",
                  top: 0,
                  left: scrollGroup.stop,
                  width: "1px",
                  height: "100%",
                  backgroundColor: "transparent"
                }}
              />
            )}

            <div
              className={classNames([
                item.show ? styles.show : "",
                styles.scrollText
              ])}
              style={{
                top: item.top + "px",
                left: item.left + "px"
              }}>
              <h3>{item.headline}</h3>
              <p>{item.text}</p>
            </div>
          </Fragment>
        )
      })
    })
  }

  return (
    <>
      <div ref={container} className={styles.scrollyHolder}>
        <div
          className={classNames([styles.process, "scrollyContent"])}
          style={{
            backgroundColor: block.attrs?.scrollyBackgroundColor
              ? block.attrs.scrollyBackgroundColor
              : "#fff",
            width: block.attrs.scrollySizeWidth + "px"
          }}>
          <div
            className={styles.scrollyContent}
            style={{
              height: block.attrs.scrollySizeHeight + "px",
              width: block.attrs.scrollySizeWidth + "px"
            }}>
            <img src={block.attrs.image} />
            <TextBox />
          </div>
        </div>
      </div>
    </>
  )
}
